<template>
  <div class="m-6">
    <template v-if="!landingParams.dealerId && !landingParams.publicId">
      <h1>Wrong url!!! Return to the dealers site!</h1>
    </template>
  </div>
</template>

<script>
export default {
  name: "Leasing",
  props: {
    dealerId: {
      type: [String, Number],
    },
    publicId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      landingParams: {
        dealerId: this.dealerId,
        publicId: this.publicId,
      },
    };
  },
  methods: {},
  created() {
    // if (this.dealerId && this.publicId) {
    //   sessionStorage.setItem(
    //     "leasing-landing-params",
    //     JSON.stringify({ dealerId: this.dealerId, publicId: this.publicId })
    //   );
    // } else {
    //   const { dealerId, publicId } = JSON.parse(
    //     sessionStorage.getItem("leasing-landing-params")
    //   );
    //   this.landingParams.dealerId = dealerId;
    //   this.landingParams.publicId = publicId;
    // }
    // if (this.landingParams.dealerId && this.landingParams.publicId) {
    //   this.$router.push({
    //     name: "LeasingLogin",
    //   });
    // }
  },
};
</script>

<style lang="scss"></style>
